module.exports = __webpack_public_path__ + "media/images/icon-hamburger-white-f1c08a3c32e2735d6a6a79311a7bfd83.svg";